import { ApiResponse } from "../types";
import { CostCenterAttributes } from "../types";
import { apiClient } from "./apiClient";

const BASE = "/cost-centers";

function buildUrl(
  path: string,
  params?: Record<string, string | number>
): string {
  if (!params || Object.keys(params).length === 0) return path;
  const search = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => search.set(k, String(v)));
  return `${path}?${search.toString()}`;
}

export const costCentersApi = {
  async getAll(
    companyId?: number
  ): Promise<ApiResponse<CostCenterAttributes[]>> {
    try {
      const url =
        companyId != null ? buildUrl(BASE, { companyId }) : BASE;
      const data = await apiClient.get<any>(url);
      return {
        success: true,
        data: Array.isArray(data)
          ? data
          : (data?.data ?? data?.costCenters ?? []),
      };
    } catch (error) {
      return {
        success: false,
        error:
          error instanceof Error ? error.message : "Unknown error occurred",
      };
    }
  },

  async getById(id: number): Promise<ApiResponse<CostCenterAttributes>> {
    try {
      const data = await apiClient.get<any>(`${BASE}/${id}`);
      return {
        success: true,
        data: data?.data ?? data,
      };
    } catch (error) {
      return {
        success: false,
        error:
          error instanceof Error ? error.message : "Unknown error occurred",
      };
    }
  },

  async create(
    payload: Omit<CostCenterAttributes, "id" | "createdAt" | "updatedAt">
  ): Promise<ApiResponse<CostCenterAttributes>> {
    try {
      const data = await apiClient.post<any>(BASE, payload);
      return {
        success: true,
        data: data?.data ?? data,
      };
    } catch (error) {
      return {
        success: false,
        error:
          error instanceof Error ? error.message : "Unknown error occurred",
      };
    }
  },

  async update(
    id: number,
    payload: Partial<
      Omit<
        CostCenterAttributes,
        "id" | "companyId" | "createdAt" | "updatedAt"
      >
    >
  ): Promise<ApiResponse<CostCenterAttributes>> {
    try {
      const data = await apiClient.put<any>(`${BASE}/${id}`, payload);
      return {
        success: true,
        data: data?.data ?? data,
      };
    } catch (error) {
      return {
        success: false,
        error:
          error instanceof Error ? error.message : "Unknown error occurred",
      };
    }
  },

  async delete(id: number): Promise<ApiResponse<void>> {
    try {
      await apiClient.delete(`${BASE}/${id}`);
      return { success: true };
    } catch (error) {
      return {
        success: false,
        error:
          error instanceof Error ? error.message : "Unknown error occurred",
      };
    }
  },
};
